<nz-layout style="height: 100%">
  <nz-sider
    *ngIf="showSider"
    nzCollapsible
    [(nzCollapsed)]="isCollapsed"
    [nzCollapsedWidth]="0"
    [nzTheme]="'light'"
    [nzBreakpoint]="'lg'"
    [nzTrigger]="null"
    nzWidth="300px"
    style="padding: 15px; border-radius: 5px"
    class="timesheet-sider"
  >
    <ng-content  select="[sider]"></ng-content>
  </nz-sider>
  <nz-layout>
    <nz-header
      style="
        background: inherit;
        padding: 0;
        height: inherit;
        margin-inline: 15px;
      "
    >
      <div class="timesheet-header">
        <nz-page-header [nzGhost]="false" style="border-radius: 5px">
          <nz-page-header-title>{{ title | locale }}</nz-page-header-title>
          <nz-page-header-extra>
            <ng-content select="[HeaderButtons]"> </ng-content>
          </nz-page-header-extra>
        </nz-page-header>
      </div>
    </nz-header>
    <nz-content style="margin: 24px 16px 0">
      <div class="timesheet-container" style="border-radius: 5px">
        <ng-content select="[content]"></ng-content>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
